<div class="rij" [class.genest]="rij().niveau > 0">
	@for (ancestorHasNext of rij().ancestorLijnen; track $index) {
		<span class="hulplijn" [class.zichtbaar]="ancestorHasNext"></span>
	}
	@if (rij().niveau > 0) {
		<span class="hulplijn zichtbaar" [class.eerste-kind]="rij().firstChild"></span>
	}
	<span class="inhoud" [class.actief]="toontAlsActief()" [class.bevat-actief]="rij().bevatActief">
		<a
			class="link"
			[routerLink]="rij().item.url"
			[queryParams]="rij().queryParams"
			[queryParamsHandling]="rij().queryParamsHandling"
			[appTooltip]="ingeklapt() ? rij().item.titel : undefined"
			tooltipPosition="right"
			(click)="onTitelClick()"
		>
			@if (rij().niveau === 0 && rij().item.icon) {
				<app-icon class="icoon" [name]="rij().item.icon!" size="medium" [color]="iconKleur()"></app-icon>
			}
			<span class="titel" [class.sr-only]="ingeklapt()">{{ rij().item.titel }}</span>
		</a>
		@if (!ingeklapt() && rij().hasChildren) {
			<button
				type="button"
				class="chevron-knop"
				[attr.aria-expanded]="rij().uitgeklapt"
				[attr.aria-label]="(rij().uitgeklapt ? 'Inklappen' : 'Uitklappen') + ' ' + rij().item.titel"
				(click)="onChevronClick($event)"
			>
				<app-icon
					class="chevron"
					[name]="rij().uitgeklapt ? 'chevron-down' : 'chevron-left'"
					size="smallest"
					[color]="rij().uitgeklapt ? 'typography-1' : 'typography-5'"
					[hoverColor]="rij().uitgeklapt ? undefined : 'typography-3'"
				></app-icon>
			</button>
		}
	</span>
</div>
